<template lang="pug">
  .contacts(v-if="content")
      .contacts__decore-wr.contacts__decore-wr--1
          img.contacts__decore.contacts__decore--1(src='@/assets/img/decor/lightning.svg' alt="decor")
      .contacts__left
          .contacts__map-wr
            .contacts__map.js-contacts-map
              .contacts__map-preloader
          .contacts__left-block
              .contacts__left-block-col
                  .contacts__left-block-item
                      SvgIcon.contacts__left-block-item-icon(name="flag" width="18" height="22")
                      .contacts__left-block-item-block
                        p.contacts__left-block-item-text {{ content.contacts.address }}
                  .contacts__left-block-item
                      SvgIcon.contacts__left-block-item-icon(name="phone" width="22" height="22")
                      .contacts__left-block-item-block
                          a.contacts__left-block-item-text.contacts__left-block-item-text--link.contacts__left-block-item-text--span(:href="content.contacts.phone[0].link") {{ content.contacts.phone[0].text }}
                          .contacts__left-block-item-phone-list-icon-wr(v-if="content.contacts.phone.length > 1" v-on:click="showPhoneList")
                            SvgIcon.contacts__left-block-item-phone-list-icon(name="arrow-2" width="9" height="14")
                          .contacts__left-block-item-text--link-list(v-if="content.contacts.phone.length > 1")
                              a.contacts__left-block-item-text.contacts__left-block-item-text--link.contacts__left-block-item-text--span(v-for="(item, index) in content.contacts.phone" :key="index" :href="item.link") {{ item.text }}
                          p.contacts__left-block-item-text телефон для заказа
              .contacts__left-block-col
                  .contacts__left-block-item
                      SvgIcon.contacts__left-block-item-icon(name="clock" width="16" height="25")
                      .contacts__left-block-item-block
                        p.contacts__left-block-item-text(v-for="(item, index) in content.contacts.timeWork" :key="index") {{ item }}
                  .contacts__left-block-item
                      SvgIcon.contacts__left-block-item-icon(name="message" width="23" height="18")
                      .contacts__left-block-item-block
                        a.contacts__left-block-item-text.contacts__left-block-item-text--link(:href="content.contacts.email.link") {{ content.contacts.email.text }}
      .contacts__right
          h2.contacts__right-headline {{ content.headline }}
          div.contacts__right-button(v-on:click="fancyboxInit") Обратная связь
          .contacts__right-form
              .contacts__right-form-wr
                  .contacts__message.contacts__message--hide
                      .contacts__message-text Ваше сообщение отправлено!
                  form.contacts__form(v-on:submit.prevent="submit")
                    legend.contacts__form-legend ОБРАТНАЯ СВЯЗЬ
                    .contacts__form-txt
                        | Обязательные поля для заполнения*
                    .contacts__form-row
                        label.contacts__form-label ФИО*
                        input.contacts__form-input(v-model="name" type="text" name="name" required)
                    .contacts__form-col
                        .contacts__form-row
                            label.contacts__form-label Email*
                            input.contacts__form-input(v-model="email" type="email" name="email" required)
                        .contacts__form-row
                            label.contacts__form-label Телефон
                            input.contacts__form-input(v-model="phone" v-mask="'+7(###)-###-###-##'" type="text" name="phone")
                    .contacts__form-row
                        label.contacts__form-label Текст сообщения*
                        textarea.contacts__form-textarea(v-model="message" name="message" required)
                    button(v-on:click="reset").contacts__form-clear Очистить
                    button.contacts__send-btn(type="submit")
                      | Отправить заявку
                    .contacts__agreement
                      | Нажимая кнопку «Отправить», Вы даёте согласие на обработку
                      router-link(to="/politika-konfidencialnosti" target="_blank").contacts__agreement-link персональных данных
      h2.contacts__headline {{ content.headline }}
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/contacts/contacts.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {YaHelpersVue} from '@/mixins/YaHelpersVue';
  import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
  import {FormHelpersVue} from '@/mixins/FormHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    name: 'Contacts',

    mixins: [AjaxHelpersVue, YaHelpersVue, PopupHelpersVue, FormHelpersVue],

    data() {
      return {
        isMapInit: false,

        // Поля формы
        name: '',
        email: '',
        phone: '',
        message: '',
        content: null,
        scrollbar: null,
      }
    },

    components: {
        SvgIcon
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadContactsPage', params => {
        this.request(params.url, params);
      });

      EventBus.$on('scrollbarInit', scrollbar => {
        this.scrollbar = scrollbar;
      });

      EventBus.$on('mapInit', myMap => {
          myMap.events.add('mousedown', () => {
              if($(window).width() < 760) {
                  if (this.scrollbar) {
                      let positonTop = $('.contacts__map').offset().top;
                      this.scrollbar.destroy();
                      $('.page').scrollTop(positonTop);
                      this.scrollbar = null;
                  }
              };
          });
      });
    },

    methods: {
      request(url, params) {
        this.req('ContactsPage:getContactsPage', {url}, res => {
          if(this.checkProperty(res.content.initMapConfig)) {
            this.content = res.content;
            EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
            EventBus.$emit('pagePreloaderHide');
            this.$nextTick(() => {
              $('.samedia').removeClass('samedia--hide');
              $('.footer').removeClass('footer--hide');
              $('.page__decore--12').removeClass('page__decore--hide-bottom');
              $('.page__decore--11').removeClass('page__decore--hide-bottom');
              $('.page__decore--10').removeClass('page__decore--hide-bottom');
              if(!this.isMapInit) {
                this.initMapLocal('.js-contacts-map', res.content.initMapConfig);
              }
              this.parallax();
              if($(window).width() < 760) {
                  this.scrollPageAdd();
              }
            })
          }
        }, 'contacts');
      },

      initMapLocal(block, initMapConfig) {
        this
          .initMap(block, initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                $('.contacts__map-preloader').addClass('contacts__map-preloader--hide');
              }, 750);
            });

            this.isMapInit = true;
          });
      },

      submit() {
        let data = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message:  this.message,
        };

        this.submitForm('ContactsPage:sendFormFeedback', data, res => {
            if(res.status == 'ok') {
                $('.contacts__form').addClass('contacts__form--hide');
                setTimeout(() => {
                    $('.contacts__message').removeClass('contacts__message--hide');
                });
                this.reset();
                this.appClasses('hide');
                dataLayer.push({'event': 'formsend'});
            }
        });
      },

      reset() {
          this.name  = '';
          this.phone = '';
          this.email = '';
          this.message = '';
      },

      parallax() {
        $(document).on('mousemove', event => {
            let offsetX = event.clientX;
            let offsetY = event.clientY;
            $('.contacts__decore-wr--1').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
        });
      },

      fancyboxInit () {
          $.fancybox.open($('.contacts__right-form'), {
              btnTpl: {
                  close: '<button data-fancybox-close class="fancybox-button--close fancybox-button-close" title="{{CLOSE}}">' +
                  '<svg width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Мобилка/Меню-открыто" transform="translate(-338.000000, -36.000000)"><g id="Group-2" transform="translate(338.000000, 36.000000)"><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-45.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-315.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect></g></g></g></svg>' +
                  '</button>',
              },
              baseTpl:
              '<div class="fancybox-container" role="dialog" tabindex="-1">' +
              '<div class="fancybox-bg"></div>' +
              '<div class="fancybox-inner">' +
              '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
              '<div class="fancybox-toolbar">{{buttons}}</div>' +
              '<div class="fancybox-stage"></div>' +
              '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
              '</div>'+
              '</div>',
              beforeShow: function () {
                  $('.fancybox-slide').css('padding', '0');
              },
              afterClose: function () {
                  $('.contacts__message').addClass('contacts__message--hide');
                  $('.contacts__form').removeClass('contacts__form--hide')
              },
              beforeClose: function () {
                  $('.fancybox-button-close').addClass('fancybox-button-close--hide');

              }
          });
      },

      scrollPageAdd() {
          $(document).on('touchmove', (event) => {
              var div = $(".contacts__map");
              if (!div.is(event.target) && div.has(event.target).length === 0 && !this.scrollbar) {
                  this.scrollInit();
              }
          });
      },

      scrollInit() {
        if($('.page__view').length) {
            this.scrollbar = new PerfectScrollbar('.page__view', {
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20
            });
            EventBus.$emit('scrollbarInit', this.scrollbar);
        }
      },

      showPhoneList() {
        $('.contacts__left-block-item-text--link-list').toggleClass('contacts__left-block-item-text--link-list--show');
        $('.contacts__left-block-item-phone-list-icon').toggleClass('contacts__left-block-item-phone-list-icon--show');
      }
    }
  }
</script>
